import React, { useEffect } from "react";
import { ArrowLeft } from "react-bootstrap-icons";
import DotsSpinner from "../Loader/DotsSpinner/DotsSpinner";
import "./mapdata.scss"

import {
  SirsaDistrict,
  Fatehabad,
  Jind,
  Bhiwani,
  Kaithal,
  Jhajjar,
  Karnal,
  Rohtak,
  Mahendragrah,
  Hisar,
  Sonipat,
  Ambala,
  Gurgoan,
  Faridabad,
  Panipat,
  NuhMewat,
  Kurukshetra,
  Yamuna_Nagar,
  Palwal,
  Panchkula,
  Rewari,
  CharkhiDadri,
} from "./AllMapsIndex";
import { IDistrictMapData } from "../../types";
import { colorHandler } from "./ColorHandler";
type IProps = {
  selectedDistrict: string;
  handleBlock: (e) => void;
  handleBack: () => void;
  isLoading: boolean;
  districtMapData : IDistrictMapData ;
};
export default function DistrictWithMap({
  selectedDistrict,
  handleBlock,
  handleBack,
  isLoading,
  districtMapData
}: IProps) { 

  const [selectedBlock, setSelectedBlock] = React.useState("");
  let objData
  const data = districtMapData?.forEach((e)=> {
    objData =  Object.assign({...objData,
      [e?.Block] : e?.Avg_Adhigam_students 
  } ) 
})
console.log("map data",districtMapData)
let uniqueId ="map"
const fillColor = (districtName: string) => {
   console.log("fill color function",districtName)
   if(districtName == `${selectedBlock.toLowerCase()}${uniqueId}`){
      return "#00a67e"
   }
   else{
  let data = districtMapData?.filter(e => `${e?.Block.toLowerCase()}${uniqueId}` == districtName)
   let val = handleColor(data[0]?.Avg_Adhigam_students);
  return val
}
}

const hoverColor ="#038aa1";

const handleColor = (remarks: number) => {
  if (remarks < 30) {
      return "#FF0000"
  }
  if (remarks => 30 && remarks < 60) {
      return "#FFFF1B"
  }
  if (remarks => 60) {
      return "#00EE33"
  }
}

  const ALLDistrict = {
    SIRSA: (
      <SirsaDistrict
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    FATEHABAD: (
      <Fatehabad
        mapData={objData ? objData : 0}
        uniqueId={uniqueId}
        hoverColor={hoverColor} 
        fillColor={(e:string)=> fillColor(e)}
        handleSelect={(e) => setSelectedBlock(e)}
        // ActiveBlock={selectedBlock}
      />
    ),
    HISAR: (
      <Hisar
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    jind: (
      <Jind
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    BHIWANI: (
      <Bhiwani
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    ROHTAK: (
      <Rohtak
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    "CHARKHI DADRI": (
      <CharkhiDadri
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    MAHENDRAGARH: (
      <Mahendragrah
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    REWARI: (
      <Rewari
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    GURUGRAM: (
      <Gurgoan
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    "NUH MEWAT": (
      <NuhMewat
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    PALWAL: (
      <Palwal
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    FARIDABAD: (
      <Faridabad
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    JHAJJAR: (
      <Jhajjar
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    SONIPAT: (
      <Sonipat
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    PANIPAT: (
      <Panipat
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    KARNAL: (
      <Karnal
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    YAMUNANAGAR: (
      <Yamuna_Nagar
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    PANCHKULA: (
      <Panchkula
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    AMBALA: (
      <Ambala
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      
      />
    ),
    KURUKSHETRA: (
      <Kurukshetra
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
    KAITHAL: (
      <Kaithal
      mapData={objData ? objData : 0}
      uniqueId={uniqueId}
      hoverColor={hoverColor} 
      fillColor={(e:string)=> fillColor(e)}
      handleSelect={(e) => setSelectedBlock(e)}
      />
    ),
  };
  useEffect(() => {
    handleBlock(selectedBlock);
  }, [selectedBlock]);
  return (
    <div>
      <div className="bg-primary  py-1 rounded flex-centered mt-4">
        <h3 className="text-white m-0">e-Adhigam Students Map</h3>
      </div>
      {isLoading ? (
        <div className="" style={{ height: "300px" }}>
          <DotsSpinner />
        </div>
      ) : (
        <>
          <div className="d-flex justify-content-between mt-3">
            <div
              className="pointer font-weight-bold border px-1 rounded"
            >
              District : {selectedDistrict.toUpperCase() } {selectedBlock && ` & Block : ${selectedBlock.toUpperCase()}`}
            </div>
            <button
              className="rounded btn-outline-primary"
              onClick={() => { selectedBlock ? setSelectedBlock("") : handleBack() }}
            >
              <ArrowLeft /> Back{" "}
            </button>
          </div>
          <div className="d-flex flex-centered mt-3   ">
            {ALLDistrict[selectedDistrict]} 
          </div>
          <div className="legend">
        <div className="item">
          <div className="item__red"></div>
          <div className="label">{`< 30%`}</div>
        </div>
        <div className="item">
          <div className="item__yellow"></div>
          <div className="label">{`> 30% and < 60%`}</div>
        </div>
        <div className="item">
          <div className="item__green"></div>
          <div className="label">{`> 60%`}</div>
        </div>
      </div>
        </>
      )}
    </div>
  );
}
